import React, { useEffect, useState } from "react";
// import users from "../../db.json";
import moment from "moment";
import axios from "axios";

export default function Prev() {
//   console.log(users);
  let newdate = moment().format("YYYY-MM-DD");
  console.log("new", newdate);
  const [ndate, setNdate] = useState(newdate);
  const [user, setUser] = useState([]);

  useEffect(() => {
    axios
      .get("http://localhost:8001/users")
      .then((response) => setUser(response.data));
  }, []);
  return (
    <>
      <h1 className="prev">Previous</h1>
      {user.map((element) => {
        console.log(element.date);
        return (
          <div>
            {ndate > element.date && element.date != "" ? (
              <>
                 <div style = {{border:"1px solid red",height:"auto",width:"auto"}}>
                    <h6 style={{ color: "orangered", fontFamily: "cursive" }}>
                      Name : {element.msg}
                    </h6>
                    <h6 style={{ color: "orangered", fontFamily: "cursive" }}>
                      Booking Date : {element.date}
                    </h6>
                    <h6 style={{ color: "orangered", fontFamily: "cursive" }}>
                      Booking Time : {element.time}
                    </h6>
                  </div>
              </>
            ) : (
              ""
            )}
          </div>
        );
      })}
    </>
  );
}
